import { useLocation, useNavigate, useOutletContext } from "react-router-dom";
import { Box, Button, Dialog, DialogContent, Stack, Switch, Toolbar, Typography } from "@mui/material"
import { Formik, Form } from "formik";
import FilterPanel from "./FilterPanel/FilterPanel";
import CustomOptionsPanel from "./CustomOptionsPanel/CustomOptionsPanel";
import { BorderBox, formatDateOnly, Loader } from "../../Helpers/Helpers";
import { getIncomestatementInfo, getIncomestatementJson, getISConfiguration, incomestatementNetIncome } from "../../API/nimbleAPI";
import { use, useEffect, useRef, useState } from "react";
import { enqueueSnackbar } from "notistack";
import clearIcon from "../../Images/clear-icon.png"
import ViewReport from "../ViewReport/ViewReport";
import { ErrorBoundary } from "react-error-boundary";
import { getJsonObject } from "../../API/backend";
import dayjs from 'dayjs';

const UserCustomizations = () => {
    const outletContext = useOutletContext();
    const SELECT_ID = "000000000000000000000000000000000000"
    const navigate = useNavigate();
    const { state } = useLocation();

    const { userSelections, ...restState } = state || {};
    const [loading, setLoading] = useState(false);
    const [defaultColumnBySelection, setDefaultColumnBySelection] = useState({})
    const [redisKeyConfigData, setRedisKeyConfigData] = useState(null)
    const [statementTypeList, setStatementTypeList] = useState(null)
    const { headerCorpId,
        menuId, authId,
        urlInfo, reportConfiguration,
        setReportConfiguration, showreport, rediskey, previleges } = outletContext;
    const formikRef = useRef(null);

    useEffect(() => {
        // if (state?.userSelections) return;
        setReportConfiguration(null)

        const fetchConfig = async () => {
            try {
                setLoading(true);
                const config = await getISConfiguration(menuId);

                //  To handle the statement type selection list based on the column types available in the configuration
                const columnTypes = config?.columnTypes ?? [];
                const hasCombined = columnTypes.some(item => item.displayId === 6);
                const hasOther = columnTypes.some(item => item.displayId !== 6);
                if (hasCombined && hasOther) {
                    setStatementTypeList("all");
                } else if (hasCombined) {
                    setStatementTypeList("combined");
                } else {
                    setStatementTypeList("default");
                }


                // To check if the user is coming from widget screen with rediskey, then we need to update the config with redis data
                if (showreport === "showreport" && rediskey) {
                    const redisConfig = await getJsonObject(rediskey);
                    setRedisKeyConfigData(redisConfig)
                    const columnBySelection = (config?.columnTypes || []).find(
                        item => item.displayId === redisConfig.GenType
                    );
                    setDefaultColumnBySelection(columnBySelection);

                    if (redisConfig?.Columns && config?.columnsList) {
                        config.columnsList = config.columnsList.map((parentColumn) => {
                            const redisColumns = redisConfig.Columns.filter(
                                (item) => item.GenType === parentColumn.displayId
                            );

                            Object.keys(parentColumn).forEach((key) => {
                                if (Array.isArray(parentColumn[key])) {
                                    parentColumn[key] = parentColumn[key].map((nestedColumn) => {
                                        const isMatched = redisColumns.some(
                                            (redisColumn) =>
                                                redisColumn.SelectedColumn === nestedColumn.dbName
                                        );

                                        return {
                                            ...nestedColumn,
                                            isDefault: isMatched,
                                        };
                                    });
                                }
                            });

                            return parentColumn;
                        });
                    }
                }
                setReportConfiguration(config);
                if (!state?.userSelections && !showreport) {
                    const isCheckDefault = (config?.columnTypes || []).find(
                        item => item.isDefault === true
                    );
                    setDefaultColumnBySelection(isCheckDefault || config?.columnTypes?.[0]);
                }
            } catch (err) {
                enqueueSnackbar("Failed to load configuration", {
                    variant: "error",
                });
            } finally {
                setLoading(false);
            }
        };

        fetchConfig();
    }, []);

    useEffect(() => {
        if (
            showreport === "showreport" &&
            reportConfiguration &&
            formikRef.current
        ) {
            formikRef.current.submitForm();
        }
    }, [showreport, reportConfiguration]);


    if (!reportConfiguration) {
        return <Loader loading />;
    }

    const previousSelectedFilters = reportConfiguration?.displaySettings[0] || {}
    const conditionalStatementType = statementTypeList === "all" ? 0 : statementTypeList === "combined" ? 1 : 0;
    const statementTypeSelection = (showreport && rediskey) ? redisKeyConfigData?.IncomestatementType : conditionalStatementType;
    const viewTransactionSelection = (showreport && rediskey) ? "Range"
        : previousSelectedFilters?.viewTransaction
            ? previousSelectedFilters.viewTransaction
            : "This Year – to – Date";
    const selectedCorpDetails =
        headerCorpId
            ? reportConfiguration?.corpList.find(c => c.id === headerCorpId)
            : null;




    const INITIALVALUES = {
        redisKeyConfigData: redisKeyConfigData,
        isMainTabsSwitch: false,
        statementType: statementTypeSelection,
        selectedManagementGroups: "All",
        selectedCrpCount: {
            selected: '',
            total: ''
        },
        // corporationIds: headerCorpId ? [headerCorpId] : [],
        corporationIds: selectedCorpDetails ? [headerCorpId] : [SELECT_ID],
        profitCenters: [],
        corporationDetails: selectedCorpDetails ? [selectedCorpDetails] : [],
        profitCenterDetails: "",
        viewTransaction: viewTransactionSelection,
        dateRange: "",
        reportType: previousSelectedFilters?.layoutType || reportConfiguration.reportType.defaultId,
        basis: previousSelectedFilters?.accrualCash || reportConfiguration.accuralOrCashType.defaultId,
        columnsBy: defaultColumnBySelection,
        columnSelections: [],
        display: {
            displayText: previousSelectedFilters?.displayTextFormat || "default",
            negativeFigures: {
                formate: previousSelectedFilters?.showNegativeFigures || "normal",
                colour: previousSelectedFilters?.showNegativeFiguresFlag === 1 ? true : false
            },
            // showAccounts: [
            //     previousSelectedFilters?.donotShowNoTransactionAccounts === 1 &&
            //     "don'tShowNoTransactionAccounts",
            //     previousSelectedFilters?.donotShowNullifiedAccounts === 1 &&
            //     "don'tShowNullifiedAccounts",
            //     previousSelectedFilters?.hideAccountCode === 1 &&
            //     "hideAccountCode",

            // ].filter(Boolean),
            showAccounts: Object.keys(previousSelectedFilters).length > 0
                ? [
                    previousSelectedFilters.donotShowNoTransactionAccounts === 1 &&
                    "don'tShowNoTransactionAccounts",
                    previousSelectedFilters.donotShowNullifiedAccounts === 1 &&
                    "don'tShowNullifiedAccounts",
                    previousSelectedFilters.hideAccountCode === 1 &&
                    "hideAccountCode",
                ].filter(Boolean)
                : [
                    "don'tShowNoTransactionAccounts",
                    "don'tShowNullifiedAccounts",
                ],
            // showFigures: [],
            showFigures: [
                previousSelectedFilters?.dividedby1000 === 1 && "dividedBy1000",
                previousSelectedFilters?.withoutcents === 1 && "withOutCents",
                previousSelectedFilters?.excludeZeroValues === 1 && "excludeZeroValues",
            ].filter(Boolean),
            viewReport: previousSelectedFilters?.showReportinFullView === 1 ? "showReportInFullView" : ""
        },
        dynamicMonthlyFilter: {
            actualForCompletedMonths: false,
            actualMonths: "",
            monthType: "following",
            foreCasteForNext: "",
            monthsCount: "",
            onlyBudgetMonths: false
        }
    };

    const generateReport = async (values, from = "generate") => {

        if (previleges && previleges?.Create === false) {
            enqueueSnackbar("You don't have create Permission.", { variant: "warning" });
            return;
        }

        const [start, end] = values.dateRange || [];

        if (values.corporationDetails.length === 0 || values.corporationDetails[0]?.id === "select") {
            enqueueSnackbar("Please select corporation", { variant: "warning" })
            return;
        };

        if (!start || !end) {
            enqueueSnackbar("Please Provide Date Range", { variant: "warning" });
            return;
        };

        if (start && end && dayjs(start).isAfter(dayjs(end), "day")) {
            enqueueSnackbar("From Date cannot be greater than To Date", { variant: "warning" });
            return;
        }

        if (values.columnSelections.length === 0) {
            enqueueSnackbar("Please select column options", { variant: "warning" })
            return;
        };


        try {
            setLoading(true);
            const transformedSelections = (values.columnSelections || [])
                .filter(item => item.displayId === values.columnsBy.displayId)
                .map(item => {
                    const result = {
                        genType: item.displayId,
                        columnId: item.columnId,
                        selectedColumn: item.dbName,
                    };
                    if (item.year !== undefined) {
                        result.lyYear = item.year;
                    }

                    return result;
                });
            const year =
                values.columnSelections?.find(i => i.year !== undefined)?.year?.toString();
            const monthTypeMap = {
                following: 2,
                current: 1,
            };

            // const corpIDs = values.corporationDetails.map(item => item.id);
            const corpDetails = [];

            (values?.corporationDetails || []).forEach(item => {
                // let row = corpDetails.find(x => x.CorpId === item.id);

                // if (row) {
                //     if (item.profitCenterID) {
                //         row.PcId += row.PcId
                //             ? `,${item.profitCenterID}`
                //             : item.profitCenterID;
                //     }
                // } else {
                //     corpDetails.push({
                //         CorpId: item.id,
                //         corporationName: item.corporationName,
                //         legalName: item.legalName,
                //         isLegalName: item.isLegalName,
                //         PcId:
                //             (values.statementType === 0 || values.statementType === 3)
                //                 ? (values.profitCenters?.length
                //                     ? values.profitCenters.join(",")
                //                     : "")
                //                 : (item.profitCenterID || "")
                //     });
                // }
                corpDetails.push({
                    CorpId: item.id,
                    corporationName: item.corporationName,
                    legalName: item.legalName,
                    isLegalName: item.isLegalName,
                    PcId:
                        (values.statementType === 0 || values.statementType === 3)
                            ? (values.profitCenters?.length
                                ? values.profitCenters.join(",")
                                : "")
                            : ""

                });
            });

            const {
                actualForCompletedMonths,
                monthType,
                actualMonths,
                foreCasteForNext,
                monthsCount,
                onlyBudgetMonths
            } = values.dynamicMonthlyFilter;

            const incomestatementJsonPayload = {
                isRegularReport: reportConfiguration?.isRegularReport || false,
                menuId: menuId,
                genType: values.columnsBy.displayId,
                layoutType: values.reportType,
                incomestatementType: values.statementType,
                managementGroup: "",
                corpIds: corpDetails,
                isAllPC: values?.profitCenterDetails === "All" ? true : false,
                startDate: formatDateOnly(values.dateRange[0]),
                endDate: formatDateOnly(values.dateRange[1]),
                accrualorCashType: values.basis,
                columns: transformedSelections,
                displayFormat: {
                    text_formate: values.display.displayText,
                    negative_figures: values.display.negativeFigures.formate,
                    show_negative_figures_in_red: values.display.negativeFigures.colour,
                    show_accounts: values.display.showAccounts,
                    show_figures: values.display.showFigures,

                },
                // corporationDetails: values.corporationDetails,
                // profitCenterDetails: values.profitCenters.length ? values.profitCenters.join(",") : "",

                ...(
                    transformedSelections.find(
                        dyM =>
                            dyM?.selectedColumn === "DynamicMonth" &&
                            values?.columnsBy.displayName === "DynamicMonthly"
                    ) && {
                        enableDynamicCols: true,
                        actualMonthMode: actualForCompletedMonths ? monthTypeMap[monthType] ?? 0 : 0,
                        actualsAfterDays: actualForCompletedMonths ? +actualMonths : 0,
                        // forecastMonths: foreCasteForNext ? +monthsCount : 0,
                        forecastMonths: 0,
                        budgetRemainMonths: onlyBudgetMonths

                    }
                ),
            };
            const incomestatementInfoPayload = {
                layoutDBName: reportConfiguration?.layoutDBName || "",
                layoutDBUrl: reportConfiguration?.layoutDBUrl || "",
                layoutDBUser: reportConfiguration?.layoutDBUser || "",
                isRegularReport: reportConfiguration?.isRegularReport || false,

                incomestatementType: values.statementType,
                UrlKey: 0,
                corpIds: corpDetails,
                isAllPC: values?.profitCenterDetails === "All" ? true : false,
                FromDate: formatDateOnly(values.dateRange[0]),
                ToDate: formatDateOnly(values.dateRange[1]),
                Lyyear: year ? year : null,
                GenType: values.columnsBy.displayId,
                ...(
                    transformedSelections.find(
                        dyM =>
                            dyM?.selectedColumn === "DynamicMonth" &&
                            values?.columnsBy.displayName === "DynamicMonthly"
                    ) && {
                        enableDynamicCols: true,
                        actualMonthMode: actualForCompletedMonths ? monthTypeMap[monthType] ?? 0 : 0,
                        actualsAfterDays: actualForCompletedMonths ? +actualMonths : 0,
                        // forecastMonths: foreCasteForNext ? +monthsCount : 0,
                        forecastMonths: 0,
                        budgetRemainMonths: onlyBudgetMonths

                    }
                ),
            }

            const [
                incomestatementJson,
                incomestatementInfo,
                netIncome
            ] = await Promise.all([
                getIncomestatementJson(incomestatementJsonPayload),
                getIncomestatementInfo(incomestatementInfoPayload),
                incomestatementNetIncome(incomestatementInfoPayload)
            ]);

            if (incomestatementJson.statuscode !== 200) {
                enqueueSnackbar(`${incomestatementJson.status}`, { variant: "warning" });
                setLoading(false);
                return
            }

            if (incomestatementInfo.statuscode !== 200) {
                enqueueSnackbar(`${incomestatementInfo.status}`, { variant: "warning" });
                setLoading(false);
                return
            };

            if (!netIncome) {
                enqueueSnackbar("Error while IncomestatementNetIncome ", { variant: "warning" });
                setLoading(false);
                return
            };

            navigate(
                `/incomestatement/${urlInfo}/${authId}/${menuId}/${headerCorpId}/report`,
                {
                    state: {
                        displayId: values.columnsBy.displayId,
                        columnSelections: transformedSelections,
                        structurePayload: incomestatementJson,
                        dataPayload: incomestatementInfo,
                        netincome: netIncome,
                        previousSelections: values,
                        incomestatementJsonPayload: incomestatementJsonPayload,
                        incomestatementInfoPayload: incomestatementInfoPayload
                    },
                }
            );


        } catch (error) {
            console.log("error", error)
            enqueueSnackbar("Error while getting generateReport", { variant: "warning" });
        } finally {
            setLoading(false);
        }

    };


    return (
        <>
            <Formik
                // initialValues={INITIALVALUES}

                innerRef={formikRef}
                initialValues={state ? state?.userSelections : INITIALVALUES}
                onSubmit={generateReport}
                enableReinitialize

            >
                {({ setFieldValue, values }) => (
                    <Form style={{ height: "100%" }}>
                        <Stack height={"100%"} width={"100%"} gap={1} p={0.5} alignContent={"center"} >
                            <Stack justifyContent={"space-between"} direction={"row"} >
                                <Box
                                    display="flex"
                                    alignItems="center"
                                    justifyContent="center"
                                    sx={{ cursor: "pointer", ml: 1 }}
                                    onClick={async () => {
                                        setLoading(true);
                                        await new Promise(resolve => setTimeout(resolve, 500));

                                        if (Object.keys(restState || {}).length === 0) {
                                            // enqueueSnackbar("Please generate the report", { variant: "warning" })
                                            window.parent.postMessage("incomeconfig", "*")
                                            setLoading(false);
                                            return;
                                        }

                                        navigate(
                                            `/incomestatement/${urlInfo}/${authId}/${menuId}/${headerCorpId}/report`,
                                            { state: restState }
                                        );
                                        setLoading(false);
                                    }}
                                >
                                    <img src={clearIcon} alt="cancel" height={25} width={25} />
                                </Box>
                                <Box
                                    display="flex"
                                    // justifyContent="flex-end"
                                    gap={2}
                                >
                                    <Button onClick={() => setFieldValue("columnSelections", [])} >Clear</Button>
                                    <Button type="submit">Generate</Button>
                                </Box>
                            </Stack>

                            <Stack direction={"row"} gap={2} height={"calc(100% - 50px)"}>
                                <Stack gap={1} height={"100%"} width={"30%"} overflow={"auto"}>
                                    <FilterPanel statementTypeList={statementTypeList} />
                                </Stack>
                                <BorderBox p={0} gap={1} height={"100%"} width={"90%"}>
                                    <CustomOptionsPanel />
                                </BorderBox>

                            </Stack>

                        </Stack>
                    </Form>
                )}
            </Formik >
            {loading && <Loader loading={loading} />
            }
        </>
    )

};

export default UserCustomizations;
